/*
* 地块管理
* */
import request from "./.request";

/*
* 园区管理
* */
export function parkSearch(e) {
  return request({
    url: '/park',
    method: 'get',
    params:e
  })
}
export function parkAdd(e) {
  return request({
    url: '/park',
    method: 'post',
    data:e
  })
}
export function parkUpdate(id,e) {
  return request({
    url: `/park/${id}`,
    method: 'put',
    data:e
  })
}
export function parkDelete(e) {
  return request({
    url: '/park',
    method: 'delete',
    params:e
  })
}



// WEBPACK FOOTER //
// ./src/api/park.js